import { Link } from 'react-router-dom';

export default function PlaceholderPage({
  eyebrow,
  title,
  subtitle,
  primaryCtaHref = "/contact",
  primaryCtaLabel = "Request Assessment",
}) {
  return (
    <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
      <div className="rounded-3xl border border-white/10 bg-[var(--gradient-card)] p-10 backdrop-blur-xl">
        <div className="text-xs font-semibold uppercase tracking-wider text-[var(--text-secondary)]">
          {eyebrow}
        </div>
        <h1
          className="mt-3 text-3xl font-semibold tracking-tight sm:text-4xl"
          style={{ fontFamily: "var(--font-display)" }}
        >
          {title}
        </h1>
        <p className="mt-4 max-w-3xl text-sm leading-7 text-[var(--text-secondary)] sm:text-base">
          {subtitle}
        </p>
        <div className="mt-7 flex flex-col gap-3 sm:flex-row">
          <Link
            to={primaryCtaHref}
            className="inline-flex items-center justify-center rounded-xl bg-[var(--accent-trust)] px-5 py-3 text-sm font-semibold text-white shadow-lg shadow-blue-500/20"
          >
            {primaryCtaLabel}
          </Link>
          <Link
            to="/"
            className="inline-flex items-center justify-center rounded-xl border border-white/10 bg-white/[0.02] px-5 py-3 text-sm font-semibold text-[var(--text-primary)] hover:bg-white/[0.05]"
          >
            Back to Home
          </Link>
        </div>
      </div>
    </div>
  );
}
